import useFeatureFlag from 'hooks/Experiments/useFeatureFlag'
import { OptimizelyFeatureFlags } from 'constants/featureFlags'

export const useRewardSeatsEnabled = () => useFeatureFlag(OptimizelyFeatureFlags.maldivesCharterRewardSeats)
